import { MenuProps } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import SvgAffiliateActive from '../../components/svg/SvgAffiliateActive';
import SvgApplyForRecognition from '../../components/svg/SvgApplyForRecognition';
import SvgApplyForRecognitionActive from '../../components/svg/SvgApplyForRecognitionActive';
import SvgBooking from '../../components/svg/SvgBooking';
import SvgBookingActive from '../../components/svg/SvgBookingActive';
import SvgCheckInOut from '../../components/svg/SvgCheckInOut';
import SvgCheckInOutActive from '../../components/svg/SvgCheckInOutActive';
import SvgCircleI from '../../components/svg/SvgCircleI';
import SvgCircleIActive from '../../components/svg/SvgCircleIActive';
import SvgConfigurationActive from '../../components/svg/SvgConfigurationActive';
import SvgConfigurationManagement from '../../components/svg/SvgConfigurationManagement';
import SvgLink from '../../components/svg/SvgLink';
import SvgLocation from '../../components/svg/SvgLocation';
import SvgLocationActive from '../../components/svg/SvgLocationActive';
import SvgOutOfYearManagement from '../../components/svg/SvgOutOfYearManagement';
import SvgOutOfYearManagementActive from '../../components/svg/SvgOutOfYearManagementActive';
import SvgSchedule from '../../components/svg/SvgSchedule';
import SvgScheduleActive from '../../components/svg/SvgScheduleActive';
import SvgStaffActive from '../../components/svg/SvgStaffActive';
import SvgStaffTypeActive from '../../components/svg/SvgStaffTypeActive';
import SvgTimeAddOpen from '../../components/svg/SvgTimeAddOpen';
import SvgTimekeepingConfirmation from '../../components/svg/SvgTimekeepingConfirmation';
import SvgTimekeepingConfirmationActive from '../../components/svg/SvgTimekeepingConfirmationActive';
import SvgUser from '../../components/svg/SvgUser';
import SvgUserType from '../../components/svg/SvgUserType';
import { ADMIN_ROUTE_NAME } from '../../constants/RouteName';
import { getItem } from '../../containers/SideBar/SidebarContent';
import SvgTimeAddClose from '../../components/svg/SvgTimeAddClose';
import { UserRoleEnum } from '../../apis/client-axios';
interface Props {
  useRole: string;
}
export const useAdminMenuItems = (props: Props): MenuProps['items'] => {
  const intl = useIntl();
  return [
    getItem(
      intl.formatMessage({ id: 'adminMenu.staffManagement' }),
      ADMIN_ROUTE_NAME.STAFF_MANAGEMENT,
      <SvgUser />,
      undefined,
      // SuperAdmin,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.staffDepartmentPosition' }),
      ADMIN_ROUTE_NAME.STAFF_DEPARTMENT_POSITION,
      <SvgUserType />,
      [
        getItem(
          intl.formatMessage({ id: 'adminMenu.staffTypeManagement' }),
          ADMIN_ROUTE_NAME.STAFF_TYPE_MANAGEMENT,
          undefined,
          undefined,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.departmentManagement' }),
          ADMIN_ROUTE_NAME.DEPARTMENT_MANAGEMENT,
          undefined,
          undefined,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.positionManagement' }),
          ADMIN_ROUTE_NAME.POSITION_MANAGEMENT,
          undefined,
          undefined,
        ),
      ],
      // SuperAdmin,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.checkInOut' }),
      ADMIN_ROUTE_NAME.ATTENDANCE_MANAGEMENT,
      <SvgCheckInOut />,
      undefined,
      // Manager,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.timekeepingConfirmation' }),
      ADMIN_ROUTE_NAME.TIMEKEEPING_CONFIRMATION,
      <SvgTimekeepingConfirmation />,
      undefined,
      // Manager,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.applyForRecognition' }),
      ADMIN_ROUTE_NAME.APPLY_FOR_RECOGNITION,
      <SvgApplyForRecognition />,
      undefined,
      // Manager,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.outOfYearManagement' }),
      ADMIN_ROUTE_NAME.OUT_OF_YEAR_MANAGEMENT,
      <SvgOutOfYearManagement />,
      undefined,
      // Manager,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.annualConfirm' }),
      ADMIN_ROUTE_NAME.ANNUAL_CONFIRMATION,
      <SvgTimeAddClose />,
      undefined,
      // Manager,
    ),
    // Employee
    getItem(
      intl.formatMessage({ id: 'adminMenu.checkInOut' }),
      ADMIN_ROUTE_NAME.EMPLOYEE_ATTENDANCE,
      <SvgCheckInOut />,
      undefined,
      // Employee,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.confirm.employee' }),
      ADMIN_ROUTE_NAME.EMPLOYEE_APPLICAIION,
      <SvgApplyForRecognition />,
      undefined,
      // Employee,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.timekeepingConfirmation' }),
      ADMIN_ROUTE_NAME.EMPLOYEE_CONFIRM,
      <SvgTimekeepingConfirmation />,
      undefined,
      // Employee,
    ),
    //Employee
    getItem(
      intl.formatMessage({ id: 'adminMenu.schedule' }),
      ADMIN_ROUTE_NAME.SCHEDULE,
      <SvgSchedule />,
      undefined,
      // SuperAdmin,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.booking' }),
      ADMIN_ROUTE_NAME.BOOKING,
      <SvgBooking />,
      undefined,
      // SuperAdmin,
    ),
    props.useRole === UserRoleEnum.SuperAdmin ? { type: 'divider' } : null,
    getItem(
      intl.formatMessage({ id: 'adminMenu.locationManagement' }),
      ADMIN_ROUTE_NAME.LOCATION_MANAGEMENT,
      <SvgLocation />,
      [
        getItem(intl.formatMessage({ id: 'adminMenu.location' }), ADMIN_ROUTE_NAME.LOCATION, undefined, undefined),
        getItem(
          intl.formatMessage({ id: 'adminMenu.locationList' }),
          ADMIN_ROUTE_NAME.LOCATION_LIST,
          undefined,
          undefined,
        ),
      ],
    ),
    props.useRole === UserRoleEnum.SuperAdmin ? { type: 'divider' } : null,

    getItem(
      intl.formatMessage({ id: 'adminMenu.configurationManagement' }),
      ADMIN_ROUTE_NAME.CONFIGURATION_MANAGEMENT,
      <SvgConfigurationManagement />,
      [
        getItem(
          intl.formatMessage({ id: 'adminMenu.logo' }),
          ADMIN_ROUTE_NAME.LOGO,
          undefined,
          undefined,
          // SuperAdmin,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.workingSchedule' }),
          ADMIN_ROUTE_NAME.WORKING_SCHEDULE,
          undefined,
          undefined,
          // SuperAdmin,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.workingHours' }),
          ADMIN_ROUTE_NAME.WORKING_HOURS,
          undefined,
          undefined,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.holiday' }),
          ADMIN_ROUTE_NAME.HOLIDAY,
          undefined,
          undefined,
          // SuperAdmin,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.choiceSettings' }),
          ADMIN_ROUTE_NAME.CHOICE_SETTINGS,
          undefined,
          undefined,
          // SuperAdmin,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.requestReview' }),
          ADMIN_ROUTE_NAME.REQUEST_REVIEW,
          undefined,
          undefined,
          // SuperAdmin,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.settingMessage' }),
          ADMIN_ROUTE_NAME.SETTING_MESSAGE,
          undefined,
          undefined,
          // SuperAdmin,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.overTime' }),
          ADMIN_ROUTE_NAME.OVERTIME_HOURS,
          undefined,
          undefined,
          // SuperAdmin,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.timeCorrection' }),
          ADMIN_ROUTE_NAME.ATTENDANCE_CONFIRMATION,
          undefined,
          undefined,
          // SuperAdmin,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.timekeepingReminder' }),
          ADMIN_ROUTE_NAME.TIMEKEEPING_REMINDER,
          undefined,
          undefined,
          // SuperAdmin,
        ),
      ],
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.affiliateAccount' }),
      ADMIN_ROUTE_NAME.AFFILIATE_ACCOUNT,
      <SvgLink />,
      undefined,
      // SuperAdmin,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.applicationList' }),
      ADMIN_ROUTE_NAME.APPLICATION_LIST,
      <SvgApplyForRecognition />,
      undefined,
      // Employee,
    ),
    getItem(
      intl.formatMessage({ id: 'adminMenu.termsOfUseAndPolicies' }),
      ADMIN_ROUTE_NAME.TERMS_OF_USE_AND_POLICIES,
      <SvgCircleI />,
      [
        getItem(
          intl.formatMessage({ id: 'adminMenu.privacyPolicy' }),
          ADMIN_ROUTE_NAME.PRIVACY_POLICY,
          undefined,
          undefined,
          // SuperAdmin,
        ),
        getItem(
          intl.formatMessage({ id: 'adminMenu.termsOfService' }),
          ADMIN_ROUTE_NAME.TERMS_OF_SERVICE,
          undefined,
          undefined,
          // SuperAdmin,
        ),
      ],
      'ant-menu-submenu-policy',
    ),
  ];
};

export const getMenuActiveIconName = (key: string): React.ReactNode => {
  switch (key) {
    case ADMIN_ROUTE_NAME.STAFF_MANAGEMENT:
      return <SvgStaffActive />;
    case ADMIN_ROUTE_NAME.STAFF_DEPARTMENT_POSITION:
      return <SvgStaffTypeActive />;
    case ADMIN_ROUTE_NAME.SCHEDULE:
      return <SvgScheduleActive />;
    case ADMIN_ROUTE_NAME.BOOKING:
      return <SvgBookingActive />;
    case ADMIN_ROUTE_NAME.LOCATION_MANAGEMENT:
      return <SvgLocationActive />;
    case ADMIN_ROUTE_NAME.ATTENDANCE_MANAGEMENT:
      return <SvgCheckInOutActive />;
    case ADMIN_ROUTE_NAME.CONFIGURATION_MANAGEMENT:
      return <SvgConfigurationActive />;
    case ADMIN_ROUTE_NAME.AFFILIATE_ACCOUNT:
      return <SvgAffiliateActive />;
    case ADMIN_ROUTE_NAME.APPLY_FOR_RECOGNITION:
      return <SvgApplyForRecognitionActive />;
    case ADMIN_ROUTE_NAME.TIMEKEEPING_CONFIRMATION:
      return <SvgTimekeepingConfirmationActive />;
    case ADMIN_ROUTE_NAME.OUT_OF_YEAR_MANAGEMENT:
      return <SvgOutOfYearManagementActive />;
    case ADMIN_ROUTE_NAME.ANNUAL_CONFIRMATION:
      return <SvgTimeAddOpen />;
    case ADMIN_ROUTE_NAME.ATTENDANCE_CONFIRMATION:
      return <SvgCheckInOutActive />;
    case ADMIN_ROUTE_NAME.EMPLOYEE_ATTENDANCE:
      return <SvgCheckInOutActive />;
    case ADMIN_ROUTE_NAME.EMPLOYEE_APPLICAIION:
      return <SvgApplyForRecognitionActive />;
    case ADMIN_ROUTE_NAME.EMPLOYEE_CONFIRM:
      return <SvgTimekeepingConfirmationActive />;
    case ADMIN_ROUTE_NAME.APPLICATION_LIST:
      return <SvgApplyForRecognitionActive />;
    case ADMIN_ROUTE_NAME.TERMS_OF_USE_AND_POLICIES:
      return <SvgCircleIActive />;

    default:
      return null;
  }
};
